module.exports = __webpack_public_path__ + "static/media/course-sc.b257e7ae.png";